import axios from "axios";

// A local .env is useful for desktop development, but must never leak into the
// production bundle: in production the API is served by the same HTTPS origin.
const backendUrl = process.env.NODE_ENV === "production"
  ? window.location.origin
  : (process.env.REACT_APP_BACKEND_URL || "http://localhost:8000");
export const API = `${backendUrl.replace(/\/$/, "")}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const sectionToken = sessionStorage.getItem("section_portal_token");
  if (sectionToken) config.headers.Authorization = `Bearer ${sectionToken}`;
  return config;
});

export function formatApiError(err, fallback = "Qualcosa è andato storto. Riprova.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function euro(n) {
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);
}

export function formatDate(value) {
  if (!value) return "—";
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : value;
}

export function formatMonth(value) {
  if (!value) return "—";
  const match = String(value).match(/^(\d{4})-(\d{2})$/);
  if (!match) return value;
  return new Intl.DateTimeFormat("it-IT", { month: "long", year: "numeric" })
    .format(new Date(Number(match[1]), Number(match[2]) - 1, 1));
}

export function fileUrl(path, token) {
  // I portali di sezione usano una sessione separata salvata nella scheda del
  // browser: i file aperti da iframe/link non passano dall'interceptor Axios.
  // Aggiungiamo quindi il token alla URL anche per anteprime e download.
  const authToken = token || sessionStorage.getItem("section_portal_token");
  return `${API}/files/${path}${authToken ? `?auth=${encodeURIComponent(authToken)}` : ""}`;
}

export async function downloadReport(type, params = {}) {
  const response = await api.get(`/report/${type}`, { params, responseType: "blob" });
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a"); link.href = url;
  link.download = `${type}-${new Date().toISOString().slice(0, 10)}.pdf`; link.click();
  URL.revokeObjectURL(url);
}
